import DoctorsPhoto from '../../../assets/images/doctors1.png'
import './about.scss'
const AboutUs = () => {
    return (
        <div className='about-us'>
            <div className="left">
                <div className="about-title">Haqqımızda</div>
                <div className="question"><span>Biz</span> Kimik?</div>
                <div className="about-desc">
                10 ildən artıq estetik sahədə təcrübəyə malik komandayıq. Peşəkar komanda, müasir texnologiyalar ilə təhlükəsiz və güvənilir estetik əməliyyatlar, əməliyyat sonrası reablitasiyalar , kosmetoloji xidmətlər göstəririk.<br />
                </div>
            </div>
            <div className="right">
                <img src={DoctorsPhoto} alt=""/>
            </div>
        </div>
    )
}

export default AboutUs
